import Vue from 'vue';
import Router from 'vue-router';
//*********** 活动类别
import actStandBy from '../pages/activityTypePage/activity1-standby';
import actAdminSend from '../pages/activityTypePage/activity2-adminSend';
import actChannelSend from '../pages/activityTypePage/activity3-channelSend';
import actBuyCoupon from '../pages/activityTypePage/activity4-buyCoupon';
import actGetCoupon from '../pages/activityTypePage/activity5-getCoupon';
import actLottery from '../pages/activityTypePage/activity6-Lottery';
import actExchange from '../pages/activityTypePage/activity7-exchange';
import actShare from '../pages/activityTypePage/activity8-share';
//*********** 商务合作
import cooperate from '../pages/cooperatePage/cooperate';
//*********** 对接文档说明
import dockH5pay from '@/pages/dockingConPage/document1-H5Pay';
import dockSdkpay from '@/pages/dockingConPage/document2-sdkPay';
import dockWnbsendC from '@/pages/dockingConPage/document3-sendCoupon';
import dockFuelAPI from '@/pages/dockingConPage/document4-fuelApi';
//*********** 首页
import homePage from '@/pages/homePage/home';
//*********** 公告
import noticeList from '@/pages/noticePage/noticeList';
import noticeDetail from '@/pages/noticePage/noticeDeatil';
//*********** 场景对接
import sceneFuel from '@/pages/scenePage/scene1-fueling';
import sceneOilPay from '@/pages/scenePage/scene2-oilPay';
import sceneLifeSer from '@/pages/scenePage/scene3-lifeSer';
import sceneDigital from '@/pages/scenePage/scene4-digital';
import sceneOilCard from '@/pages/scenePage/scene5-oilCard';

Vue.use(Router);
const router = new Router({
	mode: 'history',
	routes: [
		// 首页  1
		{
			path: '/',
			name: 'homePage',
			component: homePage,
			meta: {
				title: '佰付美营销合作平台',
				fIndex: 0,
				cIndex: 0
			}
		},
		// 活动  7
		{
			path: '/actStandBy',
			name: 'actStandBy',
			component: actStandBy,
			meta: {
				title: '佰付美营销合作平台-立减',
				fIndex: 2,
				cIndex: 0
			}
		},
		{
			path: '/actBuyCoupon',
			name: 'actBuyCoupon',
			component: actBuyCoupon,
			meta: {
				title: '佰付美营销合作平台-购券',
				fIndex: 2,
				cIndex: 1
			}
		},
		{
			path: '/actExchange',
			name: 'actExchange',
			component: actExchange,
			meta: {
				title: '佰付美营销合作平台-券码兑换',
				fIndex: 2,
				cIndex: 2
			}
		},
		{
			path: '/actChannelSend',
			name: 'actChannelSend',
			component: actChannelSend,
			meta: {
				title: '佰付美营销合作平台-渠道发券',
				fIndex: 2,
				cIndex: 3
			}
		},
		{
			path: '/actAdminSend',
			name: 'actAdminSend',
			component: actAdminSend,
			meta: {
				title: '佰付美营销合作平台-后台发券',
				fIndex: 2,
				cIndex: 4
			}
		},
		{
			path: '/actGetCoupon',
			name: 'actGetCoupon',
			component: actGetCoupon,
			meta: {
				title: '佰付美营销合作平台-领券',
				fIndex: 2,
				cIndex: 5
			}
		},
		{
			path: '/actLottery',
			name: 'actLottery',
			component: actLottery,
			meta: {
				title: '佰付美营销合作平台-抽奖',
				fIndex: 2,
				cIndex: 6
			}
		},
		{
			path: '/actShare',
			name: 'actShare',
			component: actShare,
			meta: {
				title: '佰付美营销合作平台-分享裂变',
				fIndex: 2,
				cIndex: 7
			}
		},
		// 商务合作  1
		{
			path: '/cooperate',
			name: 'cooperate',
			component: cooperate,
			meta: {
				title: '佰付美营销合作平台-商务合作',
				fIndex: 4,
				cIndex: 0
			}
		},
		// 对接文档  4
		{
			path: '/dockH5pay',
			name: 'dockH5pay',
			component: dockH5pay,
			meta: {
				title: '佰付美营销合作平台-H5支付',
				fIndex: 3,
				cIndex: 0
			}
		},
		{
			path: '/dockSdkpay',
			name: 'dockSdkpay',
			component: dockSdkpay,
			meta: {
				title: '佰付美营销合作平台-SDK对接支付',
				fIndex: 3,
				cIndex: 1
			}
		},
		{
			path: '/dockWnbsendC',
			name: 'dockWnbsendC',
			component: dockWnbsendC,
			meta: {
				title: '佰付美营销合作平台-维纳宝营销发券对接',
				fIndex: 3,
				cIndex: 2
			}
		},
		{
			path: '/dockFuelAPI',
			name: 'dockFuelAPI',
			component: dockFuelAPI,
			meta: {
				title: '佰付美营销合作平台-智慧加油API对接',
				fIndex: 3,
				cIndex: 3
			}
		},
		// 公告  2
		{
			path: '/noticeList',
			name: 'noticeList',
			component: noticeList
		},
		{
			path: '/noticeDetail',
			name: 'noticeDetail',
			component: noticeDetail
		},
		// 场景  5
		{
			path: '/sceneFuel',
			name: 'sceneFuel',
			component: sceneFuel,
			meta: {
				title: '佰付美营销合作平台-去加油',
				fIndex: 1,
				cIndex: 0
			}
		},
		{
			path: '/sceneOilPay',
			name: 'sceneOilPay',
			component: sceneOilPay,
			meta: {
				title: '佰付美营销合作平台-油卡充值',
				fIndex: 1,
				cIndex: 1
			}
		},
		{
			path: '/sceneLifeSer',
			name: 'sceneLifeSer',
			component: sceneLifeSer,
			meta: {
				title: '佰付美营销合作平台-生活服务',
				fIndex: 1,
				cIndex: 2
			}
		},
		{
			path: '/sceneDigital',
			name: 'sceneDigital',
			component: sceneDigital,
			meta: {
				title: '佰付美营销合作平台-数字娱乐',
				fIndex: 1,
				cIndex: 3
			}
		},
		{
			path: '/sceneOilCard',
			name: 'sceneOilCard',
			component: sceneOilCard,
			meta: {
				title: '佰付美营销合作平台-油证通',
				fIndex: 1,
				cIndex: 4
			}
		}
	]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js